export default __webpack_public_path__ + "img/whosWho.3ea6bd45.png";